// Vendors
import React from 'react'
import { useParams } from 'react-router'

// Functions

// Components
import { KitShowForm } from '../form/show'

// Styles
import { LayoutLoggedPageList } from 'layout/PrivatePageList'

// Types

import { PageMetaSetting } from './meta'

export const PageSampleTransportKitShowRecord = (): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const { id } = useParams<{ id: string }>()
  const { endpoint, title } = PageMetaSetting

  /*
  |-----------------------------------------------------------------------------
  | Effects
  |-----------------------------------------------------------------------------
  |
  |
  */

  /*
  |-----------------------------------------------------------------------------
  | Memos.
  |-----------------------------------------------------------------------------
  |
  |
  */

  /*
  |-----------------------------------------------------------------------------
  | Renders.
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <LayoutLoggedPageList title={title}>
      <KitShowForm endpoint={endpoint} id={id} />
    </LayoutLoggedPageList>
  )
}
